<template lang='pug'>
el-dialog.modal-inibir-restricoes(
    :visible.sync='mostrarDialog',
    :close-on-click-modal='false',
    :destroy-on-close='true',
    :show-close='false',
    width='30%'
)
    div(
        style='background: white; height: auto; padding: 20px; border-radius: 5px'
    )
        section.mb-4.template(slot='title')
            .modal-inibir-restricoes__header
                .modal-inibir-restricoes__header--icon
                    i.el-icon-warning-outline
                .modal-inibir-restricoes__header--title
                    | {{ $t('mensagens.operacao.monitoramento.inibirRestricoes') }}

        section.modal-inibir-restricoes__body
            .modal-inibir-restricoes__body--descricao
                span {{ $t('mensagens.operacao.monitoramento.inibindoRestricoesAtivasCamada') }}
                p.m-0.mb-3
                    strong {{ camada.nome }}

                .modal-inibir-restricoes__body--form
                    el-form(
                        label-position='top',
                        ref='formInibirRestricoes',
                        :model='payload',
                        :rules='formRules'
                    )

                        .modal-inibir-restricoes__body--restricao(v-for="(restricao, index) in restricoes")
                            .modal-inibir-restricoes__body_restricao--infos
                                p.m-0
                                    span {{ $t('mensagens.operacao.tabela.nome') }}:
                                    |
                                    | {{ restricao.properties.nome || '-' }}
                                    br
                                    span {{ $t('mensagens.operacao.monitoramento.areaDesmatamento') }}:
                                    |
                                    | {{ formatNumber(restricao.properties.areaHa) || '-' }}
                                    br
                                    span {{ $t('mensagens.operacao.monitoramento.percentual') }}:
                                    |
                                    | {{ formatNumberPercent(restricao.properties.percentualSobreposicaoGeometria) || '-' }}

                                el-tooltip(
                                    effect='dark'
                                    :content="$t('mensagens.operacao.monitoramento.excluiAreaSelecionada')"
                                    placement='left-start'
                                    style='height: 20px'
                                )
                                    i.mdi.mdi-trash-can-outline(@click="removerRestricao(index)")

                            .modal-inibir-restricoes__body__restricao--operacoes.mb-3
                                el-form-item(
                                    prop='operacoes',
                                    v-if='restricao.carregandoOperacoes || (restricao.operacoes.length > 0 && payload.restricaoOperacao.length > 0)'
                                )
                                    template(slot='label')
                                        span.label {{ $t('mensagens.operacao.monitoramento.selecionarOperacoes') }}
                                    el-select.w-100(
                                        v-model='payload.restricaoOperacao[index].idsOperacoes',
                                        :loading='restricao.carregandoOperacoes'
                                        multiple,
                                        filterable,
                                        collapse-tags,
                                        :placeholder="restricao.carregandoOperacoes ? $t('mensagens.operacao.monitoramento.carregando') : $t('mensagens.operacao.monitoramento.cliqueSelecionar')",
                                        value-key='id'
                                    )
                                        el-option(
                                            v-for='operacao in restricao.operacoes',
                                            :key='operacao.id',
                                            :label='montarLabelOpcoes(operacao)',
                                            :value='operacao.id'
                                        )

                            hr

                        el-form-item(prop='justificativa')
                            template(slot='label')
                                span.label.campo_obrigatorio {{ $t('mensagens.operacao.monitoramento.selecionarJustificativa') }}
                            el-select.w-100(
                                v-model='payload.idJustificativa',
                                :placeholder="$t('mensagens.operacao.monitoramento.cliqueSelecionar')",
                                value-key='id'
                            )
                                el-option(
                                    v-for='justificativa in justificativas',
                                    :key='justificativa.id',
                                    :label='justificativa.nome',
                                    :value='justificativa.id'
                                )

                        el-form-item(prop='descricao')
                            template(slot='label')
                                span.label {{ $t('mensagens.operacao.formularioGeral.descricao') }}

                            el-input(
                                v-model='payload.descricaoJustificativa',
                                type='textarea',
                                :rows='3',
                                :placeholder="$t('mensagens.operacao.monitoramento.digiteJustificativa')"
                            )

        section.modal-inibir-restricoes__action
            BaseButton(size='mini', @click='fechar')
                | {{ $t('mensagens.comuns.voltar') }}
            BaseButton(type='primary', size='mini', @click='inibirRestricoes')
                | {{ $t('mensagens.comuns.salvar') }}
</template>

<script>
import formatters from '@/utils/formatters';
import OperacaoMonitoramentoService from '@/services/OperacaoMonitoramentoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalInibirRestricoes',

    components: {
        BaseButton
    },

    emits: ['atualizar-restricoes-inibidas'],

    props: {
        idOperacao: {
            required: true
        },
        restricoesSelecionadas: {
            type: Array,
            required: true,
            default: () => ([{
                operacoes: [],
                restricao: {}
            }])
        },
        camada: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            mostrarDialog: false,
            payload: {
                codigoCamada: null,
                idJustificativa: null,
                descricaoJustificativa: null,
                acao: 'INSERIR',
                restricaoOperacao: []
            },
            formRules: {
                justificativa: [
                    { validator: this.checkRuleJustificativa, trigger: 'blur' }
                ],
                descricao: [
                    { validator: this.checkRuleDescricao, trigger: 'blur' }
                ]
            },
            restricoes: [],
            operacoes: [],
            justificativas: []
        };
    },

    watch: {
        mostrarDialog: function(value) {
            if (value) {
                this.payload.codigoCamada = this.camada.codigo;
                this.restricoes = this.restricoesSelecionadas;
                this.restricoes.forEach((restricao) => {
                    this.payload.restricaoOperacao.push({ idsOperacoes: [], codigoRestricao: restricao.id });
                });

                setTimeout(() => {
                    let dialogBody = document.getElementsByClassName('el-dialog__body');
                    dialogBody[1].firstChild.style.height = '60vh';
                    dialogBody[1].firstChild.style.overflowY = 'scroll';
                }, 100);

                this.buscarOperacoesInibicao();
                this.buscarJustificativas();
            }
        }
    },

    methods: {
        buscarOperacoesInibicao() {
            this.restricoes.forEach(async restricao => {
                restricao.carregandoOperacoes = true;

                await OperacaoMonitoramentoService.buscarOperacoesInibicao({
                    idOperacao: this.idOperacao,
                    codigoRestricao: restricao.id,
                    acao: 'INSERIR'
                })
                .then(({ data }) => {
                    restricao.operacoes = data.itens;
                    restricao.carregandoOperacoes = false;
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.erroInibicao')
                    })
                )
                .finally(() => { restricao.carregandoOperacoes = false; });
            });
        },
        async buscarJustificativas() {
            await OperacaoMonitoramentoService.buscarJustificativasInibirRestricoes()
                .then(({ data }) => {
                    this.justificativas = data.itens;
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.erroJustificativaInibicao')
                    })
                );
        },
        checkRuleJustificativa(rule, value, callback) {
            if (this.payload.idJustificativa === null) {
                return callback(
                    new Error(this.$t('mensagens.operacao.notificacao.justificativaMinima'))
                );
            }
            callback();
        },
        checkRuleDescricao(rule, value, callback) {
            if (this.payload.descricaoJustificativa?.length > 1000) {
                return callback(
                    new Error(this.$t('mensagens.operacao.notificacao.descricaoExcessiva'))
                );
            }
            callback();
        },
        async inibirRestricoes() {
            const formValidado = await this.$refs.formInibirRestricoes
                .validate()
                .then(value => value)
                .catch(() => false);

            if (!formValidado) return;

            this.payload.restricaoOperacao.forEach(restricao => {
                restricao.idsOperacoes.push(this.idOperacao);
            });

            await OperacaoMonitoramentoService.inibirRestricao(this.payload)
                .then(({ data }) => {
                    this.$notify.success({
                        message: data,
                        duration: 10000
                    });
                    this.fechar();
                    this.$emit('atualizar-restricoes-inibidas', this.restricoes);
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.inibirRestricaoSuporte1') +
                            this.$t('mensagens.operacao.notificacao.inibirRestricaoSuporte2')
                    });
                    this.fechar();
                })
                .finally(() => {
                    this.payload = {
                        codigoCamada: null,
                        idJustificativa: null,
                        descricaoJustificativa: null,
                        acao: 'INSERIR',
                        restricaoOperacao: []
                    };
                });
        },
        montarLabelOpcoes(operacao) {
            return this.$t('mensagens.operacao.monitoramento.id') + ': ' + operacao.identificador + ' | ' + this.$t('mensagens.operacao.tabela.nome') + ': ' + (operacao.nome ? operacao.nome : '--');
        },
        removerRestricao(indexRestricao) {
            this.restricoes.splice(indexRestricao, 1);
            this.payload.restricaoOperacao.splice(indexRestricao, 1);

            if (this.restricoes.length === 0) {
                this.fechar();
            }
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + ' ha';
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        },
        fechar() {
            this.mostrarDialog = false;
        }
    }
};
</script>

<style lang='scss'>
.modal-inibir-restricoes {
    display: flex;

    .modal-inibir-restricoes__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .modal-inibir-restricoes__header--icon {
            margin-right: 10px;
            font-size: 20px;
            color: #fec556;
        }

        .modal-inibir-restricoes__header--title {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .modal-inibir-restricoes__body {
        width: 100%;

        .modal-inibir-restricoes__body--descricao {
            font-weight: 500;
            font-size: 14px;
            word-break: break-word;
        }

        .modal-inibir-restricoes__body_restricao--infos {
            display: flex;
            justify-content: space-between;

            i {
                margin-bottom: 15px;
                font-size: 20px;
                color: red;
                cursor: pointer;
            }
        }

    }

    .modal-inibir-restricoes__action {
        height: 50px;
        border-top: solid 2px #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }

    .el-dialog {
        background: none !important;
    }

    .el-dialog__body {
        padding: 20px;
    }

    .el-form-item__label {
        padding: 0 !important;
        margin-top: 5px !important;
    }

    .campo_obrigatorio::after {
        content: '*';
        color: red;
    }
}
</style>
